import React, { FC } from 'react';
import './DocumentForm.css';
import {
	InputField,
	SelectField,
	RequiredNote,
	FaFile,
	FaFolder,
	useBreakPoint,
	DomainFormProps,
	SelectOptionType,
	AppEnum,
	GenerateUIFile,
} from '@/Shared';

import { SingleValue } from 'react-select';
import KnownSourceDocForm from './KnwonSourceDocForm';
import UploadDocForm from './UploadDocForm';

export interface DocumentFormProps {
	document: GenerateUIFile;
	handleClose: () => void;
	handleCancel: () => void;
	id : number;
}

/**
 * =====================================================
 * Component: DocumentForm
 * =====================================================
 *
 *
 * Domain-specific form UI for Document.
 * Mounted inside GenericDomainForm.
 *
 * Responsibilities:
 * - Render activity fields
 * - Use data from formVM (options, values)
 *
 * No permissions, no loading, no orchestration logic here.
 *
 * Author: Samano CASTRE
 * Date: February 15, 2026
 */
const DocumentForm: FC<DomainFormProps> = ({
	domainFormHook,
	formRef,
	formikProps,

}) => {

	const { isDesktop } = useBreakPoint();

	const { values, setFieldValue } = formikProps;
	const { entityFormVM, isModalMode } = domainFormHook;

	/**
	 * Read-only category/type fields used when the form is opened in modal mode.
	 * In this case, category and type are fixed and cannot be changed.
	 */
	const getCatAndTypeInputFields = () => {
		return (
			<>
				<InputField
					label='Catégorie'
					required
					icon={<FaFolder />}
					name='documentCategory'
					value={entityFormVM.documentCategoryLabel}
					readOnly
				/>
				<InputField
					label='Type du document'
					required
					icon={<FaFolder />}
					name='documentType'
					value={entityFormVM.documentTypeLabel}
					readOnly
				/>
			</>
		);
	}

	/**
	 * Selectable category/type fields used in standalone mode.
	 * Allows the user to choose the document category and type,
	 * which will dynamically drive the rest of the form.
	 */
	const geCatAndTypeSelectFields = () => {
		return (
			<>
				<SelectField
					label='Catégorie'
					required
					icon={<FaFolder />}
					name='documentCategory'
					options={entityFormVM.categoryOptions}
					readOnly={isModalMode}
					scrollParent={formRef.current}
					placeholder="Choisir la catégorie du document"
					onChange={
						(selectedOption) => {
							const option = selectedOption as  SingleValue<SelectOptionType>;
							entityFormVM.onCategoryChanged(option?.value);
							setFieldValue('documentCategory', option?.value);
						}
					}
				/>
				<SelectField
					label='Type du document'
					required
					icon={<FaFolder />}
					name='documentType'
					options={entityFormVM.typeOptions}
					readOnly={isModalMode}
					scrollParent={formRef.current}
					placeholder="Choisir un type du document"
				/>
			</>
		);
	}


	return (

		<div className={isDesktop ? 'flex-row-nowrap' : 'flex-col'}>

			 	<div className="fieldset-wrapper">

				{/* Common document fields shared across all categories */}
				<fieldset>
					<legend>Caractéristiques Générales</legend>
					<InputField
						label='Titre du document'
						required
						icon={<FaFile />}
						name='documentTitle'
						placeholder='Saisir le titre du document'
						autoComplete='on' />
					{
						isModalMode ?
							getCatAndTypeInputFields() :
							geCatAndTypeSelectFields()
					}
					<RequiredNote />
				</fieldset>

				{/* Category/type-specific fields*/ 
				
					entityFormVM.isSourceKnown()
						? <KnownSourceDocForm
								scrollParent={formRef.current}
								options={entityFormVM.getKnownSourceOptions()}
								isModalMode={!!isModalMode}
							/>
						: <UploadDocForm values={values} />
				}
			</div>
		</div>
	);
}
export default DocumentForm;

